<template>
  <div class="container-fluid" style="padding: 20px 0">
    <div class="row">
      <div class="col">
        <div class="page-title m-plus-medium">本人確認</div>
      </div>
    </div>
    <div class="row" style="margin-top: 10px">
      <div class="col-3">
        <button
          class="btn btn-kinkyer"
          style="width: 150px !important"
          @click="checkOK()"
        >
          チェック完了
        </button>
      </div>
      <div class="col-3">
        <button
          class="btn btn-danger"
          style="width: 150px !important"
          @click="checkBack()"
        >
          差し戻し
        </button>
      </div>
      <div class="col-3"></div>
    </div>
    <div class="row" style="margin-top: 10px">
      <div
        class="col-4"
        style="margin-top: 15px"
        v-for="user in users"
        :key="user.id"
      >
        <div class="card" style="border: 0 !important">
          <div>
            <listImage :uid="user.uid" />
          </div>
          <div class="card-body">
            <div>{{ user.name || "******" }}</div>
            <div>
              誕生日：{{ setDateView(user.birthday) }}({{ user.age || "*" }}際)
            </div>
            <div>登録日：{{ setDateView(user.createdAt) }}</div>
            <div class="text-center" style="padding-top: 10px">
              <input
                type="checkbox"
                style="width: 25px; height: 25px"
                @click="setSelectedUser(user.uid)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listImage from "./IdentificationImage.vue";
import { db, storage } from "../../plugins/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";
import { ref as storageRef, getDownloadURL } from "firebase/storage";

export default {
  data() {
    return {
      users: [],
      usersCollection: null,
      selectUsers: [],
    };
  },
  components: {
    listImage,
  },
  async mounted() {
    this.findUsers();
  },
  methods: {
    async findUsers() {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("isEntry", "==", false));
      const querySnapshot = await getDocs(q);

      this.users = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    },
    setDateView(date) {
      try {
        let status = "今";
        let lg = new Date(date.toDate());

        const yyyy = lg.getFullYear();
        const mm = ("00" + (lg.getMonth() + 1)).slice(-2);
        const dd = ("00" + lg.getDate()).slice(-2);
        status = `${yyyy}年${mm}月${dd}日`;

        return status;
      } catch {
        return "***";
      }
    },
    setSelectedUser(uid) {
      const index = this.selectUsers.indexOf(uid);
      if (index === -1) {
        this.selectUsers.push(uid); // 追加
      } else {
        this.selectUsers.splice(index, 1); // 削除
      }
    },
    async setImages(uid) {
      const imageRef = storageRef(storage, `users/icon/${uid}/user_icon1.png`);

      try {
        const url = await getDownloadURL(imageRef);
        return url;
      } catch (error) {
        console.error("Error fetching image URL:", error);
        return "";
      }
    },
    /// isIdentification = true
    /// isReIdentification = false
    checkOK() {
      this.selectUsers.forEach(async (uid) => {
        // 年齢確認完了
        const docLikeForUserDetail = doc(db, "users", uid);
        await updateDoc(docLikeForUserDetail, {
          isEntry: true,
          isIdentification: true,
          isReIdentification: false,
        });
      });
      this.findUsers();
    },
    /// isReIdentification=true
    checkBack() {
      this.selectUsers.forEach(async (uid) => {
        // 差し戻し
        const docLikeForUserDetail = doc(db, "users", uid);
        await updateDoc(docLikeForUserDetail, {
          isReIdentification: true,
        });
      });
      this.findUsers();
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 30px;
  font-weight: bold;
  color: #827490;
}
</style>
